/**
 * Controller para a diretiva de visualização de dados de endereço de cliente. 
 */

angular.module("avlib").controller(
		"addressEditorController", 
		["$scope", "$log", "$q", "addressService", "viaCepService", "msgDisplayService", "countryConst",
		function AddressEditorController(
				$scope, $log, $q,
				addressService, viaCepService, msgDisplayService, 
				countryConst) {

	/**
	 * Inicializa o controlador.
	 */
	var init = function(){
		/*
		 * Solicitando a carga de dados exigidos pelo controlador. Os dados de municípios só
		 * será efetuada quando o endereço a ser editado tiver sido carregado no escopo. Só
		 * então saberemos de qual Estado devem ser lidos os municípios.
		 */
		$q.all([
	        addressService.getCountries(),
	        addressService.getStates(),
		]).then(function(data){
			$scope.countries = data[0];
			$scope.states    = data[1];
		});	
	};
			
	/**
	 * Indica se no momento está em curso uma consulta ao servidor dos Correios por um endereço
	 * a partir de CEP informado pelo usuário. Será utilizado para bloquear temporariamente
	 * os campos da interface que serão automaticamente preenchidos com o resultado da consulta
	 * que encontra-se em execução.
	 */
	var loadingZipcode = false;	
	
	/**
	 * Obtém todos os municípios de um determinado estado.
	 * 
	 * @param stateId o identificador do estado do qual os municípios serão obtidos
	 * @param callback função a ser executada caso a obtenção dos municípios ocorra com sucesso
	 */
	var getCities = function(stateId, callback){
		$log.debug("Controlador solicitando dados do município "+stateId);
		addressService.getCities(stateId).then(function(cities){
			$log.debug("Dados de municípios carregados com sucesso.");
			$scope.cities = cities;
			if (callback){
				$log.debug("Delegando para callback.");
				callback(cities);
			}
		}, function(response){
			$log.debug("Falha ao carregar dados de municípios: "+response.status+" "+response.statusText);
		});
	};		
	
	/**
	 * Obtém um país específico a partir do array de países carregado no escopo.
	 * 
	 *  @param countryId o identificador do país a ser encontrado
	 */
	var getCountryById = function(countryId){
		if ($scope.countries){
			return $scope.countries.find(function(country){
				return country.id == countryId;
			});
		}
		return null;
	};	
	
	/**
	 * Obtém um estado específico a partir do array de estados carregado no escopo.
	 * 
	 * @param stateId o identificador do estado a ser encontrado
	 */
	var getStateById = function(stateId){
		if ($scope.states){
			return $scope.states.find(function(state){
				return state.id == stateId;
			});
		}
		return null;
	};

	/**
	 * Obtém um município específico a partir do array de municípios carregado no escopo.
	 * 
	 * @param cityId o identificador da cidade a ser encontrada
	 */
	var getCityById = function(cityId){
		if ($scope.cities){
			return $scope.cities.find(function(city){
				return city.id == cityId;
			});
		}
		return null;
	};
	
	/**
	 * Dispara uma requisição para o servidor para realizar a carga de dados
	 * combo de municípios, em função do código de Estado informado. Se
	 * for especificado um código de município, seleciona este município
	 * na sequência.
	 * 
	 * @param stateId o identificador do estado que será selecionado
	 * @param cityId o identificador do município que será selecionado
	 */
	var loadStateAndSetCity = function(stateId, cityId){
		$scope.address.state = getStateById(stateId);
		getCities(stateId, function(cities){
			$scope.address.city = getCityById(cityId);
		});
	};
	
	/*
	 * Carga de dados e funções no $scope: 
	 */
	
	/*
	 * Coleções trazidas do servidor para popular as combos
	 * de seleção apresentadas pela interface:
	 */
	$scope.countries = [];
	$scope.states = [];
	$scope.cities = [];
	
	$scope.$watch("addressForm.$valid", function(newValue, oldValue){
		if ($scope.callbacks){
			$scope.callbacks.setValid(newValue);
		}
	});
	
	/*
	 * Quando acontece o refresh da página, os dados de endereço não estão prontamente disponíveis defido a latência
	 * de busca das informações no servidor. Portanto, não podemos realizar parte da configuração do controlador na
	 * sua inicialização. Precisamos aguardar que os dados de endereço estejam crregados no contexto.
	 */
	$scope.$watch("address", function(){
		if ($scope.address){
			/*
			 * Criando a promise responsável por buscar os municípios referentes ao Estado do endereço:
			 */
			if ($scope.address.state){
				addressService.getCities($scope.address.state.id).then(function(cities){
					$scope.cities = cities;
				},function(response){
					$log.debug("Falha na carga de cidades referente ao Estado do endereço.", response);
				});
			}
			/*
			 * Apesar da máscara de CEP utilizada na interface gerar objetos do modelo em formato
			 * numérico, ela exige que a inicialização seja feita por um objeto string.
			 * Certamente este é um bug da biblioteca.
			 */
			if ($scope.address.zip_code){
				$scope.address.zip_code = ""+$scope.address.zip_code;
			}
			/*
			 * Quando um novo contato é cadastrado no sistema, seu endereço é vazio, inclusive o
			 * país. Para facilitar o preenchimento de dados, quando não houver informação de país,
			 * vamos ajustar por default o Brasil, que deve atender a grande maioria dos casos.
			 */
			if ($scope.address.country == null){
				$scope.address.country = {id:countryConst.BRAZIL};
			}
		}
	});
	
	/**
	 * Indica se o endereço que está sendo preenchido no cadastro é um endereço nacional
	 * ou estrangeiro.
	 */
	$scope.isForeignAddress = function(){
		if ($scope.address.country){
			return countryConst.BRAZIL !== $scope.address.country.id;
		}
		return false;
	};
	
	/**
	 * Indica se o campo de cadastramento de CEP está habilitado na interface. 
	 */
	$scope.isZipcodeFieldEnabled = function(){
		return $scope.address.country && !loadingZipcode;
	};
	
	/**
	 * Indica se a combo de seleção de Estado está habilitada na interface. 
	 */
	$scope.isStateComboEnabled = function(){
		return $scope.address.country && !loadingZipcode;
	};
	
	/**
	 * Indica se a combo de seleção de município está habilitada na interface. 
	 */
	$scope.isCityComboEnabled = function(){
		return $scope.address.country && $scope.address.state && !loadingZipcode;
	};
	
	/**
	 * Indica se o campo de cadastramento de bairro está habilitado na interface. 
	 */
	$scope.isDistrictFieldEnabled = function(){
		return $scope.address.country && !loadingZipcode;
	};
	
	/**
	 * Indica se o campo de cadastramento de logradouro está habilitado na interface. 
	 */
	$scope.isStreetFieldEnabled = function(){
		return $scope.address.country && !loadingZipcode;
	};
	
	/**
	 * Indica se o campo de cadastramento de número está habilitado na interface. 
	 */
	$scope.isNumberFieldEnabled = function(){
		return $scope.address.country;
	};	
	
	/**
	 * Indica se o campo de cadastramento de apartamento está habilitado na interface. 
	 */
	$scope.isApartmentFieldEnabled = function(){
		return $scope.address.country;
	};	
	
	/**
	 * Indica se o campo de cadastramento de ponto de referência está habilitado na interface. 
	 */
	$scope.isDirectionsFieldEnabled = function(){
		return $scope.address.country;
	};	
	
	/**
	 * Indica se o campo de país está visivel na interface 
	 */
	$scope.isCountryVisible = function(){
		return $scope.countryVisible == undefined || $scope.countryVisible;
	};	
	
	/**
	 * Indica se existem dados a serem apresentados na visualização de endereço.
	 */
	$scope.hasAddressData = function(){
		if ($scope.address){
			return addressService.hasData($scope.address);
		}else{
			return false;
		}
	};
	
	/*
	 * Listeners
	 */

	$scope.enterHit = function(){
		$scope.callbacks.save();
	};
	
	/**
	 * Listener para a combo de seleção de Estado.
	 */
	$scope.stateSelected = function(){
		if ($scope.address.state){
			$log.debug("Estado selecionado pelo usuário: "+$scope.address.state.ibge_code);
			getCities($scope.address.state.id);
		}else{
			$log.debug("Usuário desmarcou combo de Estados.");
			// Garantindo que não exista município selecionado se não há Estado selecionado.
			$scope.address.city = null;
		}
	};
	
	/**
	 * Listener para o campo de CEP.
	 */	
	$scope.zipcodeEntered = function(){
		/*
		 * Para garantir que a validação personalizada de "CEP não encontrado" não
		 * fique indevidamente sendo apresentada para o usuário, toda vez que o
		 * campo muda de valor, limpamos esta falha de validação:
		 */
		$scope.addressForm.zipcode.$setValidity('serverZipcode', true);
		if ($scope.address.zip_code){
			$log.debug("Buscando endereço pelo CEP: "+$scope.address.zip_code);
			/*
			 * Antes de iniciar a busca por CEP, primeiramente bloqueamos os campos que
			 * potencialmente serão preenchidos com o resultado da busca:
			 */
			loadingZipcode = true;
			
			viaCepService.getAddress($scope.address.zip_code).then(function(address){
				loadStateAndSetCity(address.state.id, address.city.id);
				$scope.address.district = address.district;
				$scope.address.street = address.street;
				$scope.address.street_number = null;
				$scope.address.apartment = null;
				$scope.address.address_directions = null;
			}, function(reason){
				if (reason.error == viaCepService.INVALID_ZIPCODE_ERROR){
					/*
					 * Se o CEP não foi encontrado, aplicamos uma validação personalizada no campo
					 * "zipcode" do formulário, para que o usuário seja sinalizado do problema:
					 */
					$scope.addressForm.zipcode.$setValidity('serverZipcode', false);
				}else{
					$log.debug("Houve uma falha de comunicação na busca do CEP. "+reason.textStatus+" "+reason.error);
					msgDisplayService.showToast("Falha do servidor na busca por CEP.");
				}
			}).finally(function(){
				/*
				 * Independentemente do resultado da busca por CEP, reativamos os campos que
				 * haviam sido temporariamente bloqueados:
				 */
				loadingZipcode = false;
				// Essa chamada garante que a interface seja corretamente atualizada:
				setTimeout(function(){$scope.$apply()},0);
			});
		}
	};
	
	init();
}]);
